/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/channels",
    },
    (router) => {
      router.push({
        id: "@api/channel@search",
        path: "",
      });

      router.group(
        {
          path: "/:channelId",
        },
        (router) => {
          router.push({
            id: "@api/channel@view",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/channel@calendar",
                path: "/calendar",
              });
            },
          );
        },
      );

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api/channel@configuration",
            path: "/configuration",
          });
        },
      );
    },
  );
}
